<template>
    <div class="search-bar">
        <div class="label">
            {{label}}：
        </div>

        <div class="list">
            <div 
            class="item" 
            :class="{active: value === item[props.value]}"
            v-for="(item, index) in usingData"
            :key="index"
            @click="clickHandler(item,index)"
            >
                {{item[props.label]}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        props: {
            type: Object,
            default: () => ({
                label: 'dicname',
                value: 'diccode',
            }),
        },
        action: {
            type: String,
            default: '',
        },
        all: {
            type: Boolean,
            default: true,
        },
        afterClick: {
            type: Function,
            default: function(){}
        },
    },
    data() {
        return {
            innerData: [],
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        usingData() {
            if (this.action) {
                return this.innerData;
            } else {
                return this.data;
            }
        },
    },
    methods: {
        clickHandler(item,index) {
            this.model = item[this.props.value];
            !!this.afterClick && this.afterClick(item, index);
        },
        queryData() {
            if (!this.action) return;

            this.$get(this.action, data => {
                if (this.all) {
                    data.unshift({
                        [this.props.label]: '全部',
                        [this.props.value]: '',
                    });
                }
                
                this.innerData = data;
            });
        },
    },
    mounted() {
        if(this.$route.query.fileType){ 
            for(var i=0;i<this.usingData.length;i++){
                if(this.usingData[i].dictName==this.$route.query.fileType){
                    this.value = this.usingData[i].dictCode
                    this.model = this.usingData[i].dictCode
                }
            }
        }
        this.queryData();
    },
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .search-bar {
        overflow: hidden;
        color: #333;
        line-height: 1em;
        padding: 20px 0;

        & + .search-bar{
            border-top: 1px dashed #F0F0F0;
        }

        .label {
            float: left;
            margin-right: -6em;
            font-weight: bold;
        }

        .list {
            overflow: hidden;
            margin: -8px 0;
            margin-left: 6em;
            float: left;

            .item{
                float: left;
                margin: 8px 24px 8px 0;
                cursor: pointer;

                &:hover{
                    color: $primaryColor;
                }

                &.active{
                    color: $primaryColor;
                    font-weight: bold;
                }
            }
        }
    }
</style>